import { render, staticRenderFns } from "./VipSwiper.vue?vue&type=template&id=50ecd6f9&lang=html"
import script from "./VipSwiper.vue?vue&type=script&lang=js"
export * from "./VipSwiper.vue?vue&type=script&lang=js"
import style0 from "./VipSwiper.vue?vue&type=style&index=0&id=50ecd6f9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports